/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiApp } from 'api/request';
import urlApp from 'api/urlApp';
import { size } from 'lodash';
import HttpRequestError from 'utils/HttpRequetsError';

export async function getListKhoHangApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getListKhoHang, {params: payload});
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postCreateListKhoHangApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postCreateListKhoHang, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postUpdateDefaultKhoHangApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postUpdateDefaultKhoHang, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postUpdateStatusKhoHangApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postUpdateStatusKhoHang, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postUpdateKhoHangApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postUpdateKhoHang, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}